import CalendarPage from "./CalendarPage";

export default function AdminCalendar() {
  return <CalendarPage isAdmin={true} />;
}
